import { render, staticRenderFns } from "./HomeRelease.vue?vue&type=template&id=25445d58&scoped=true"
import script from "../controllers/HomeRelease.ts?vue&type=script&lang=ts&external"
export * from "../controllers/HomeRelease.ts?vue&type=script&lang=ts&external"
import style0 from "./HomeRelease.vue?vue&type=style&index=0&id=25445d58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25445d58",
  null
  
)

export default component.exports